import { useRef } from 'react'
import { useLocation, useMatch, useNavigate } from 'react-router-dom'
import { getPrimaryKeyFromPath } from '@/config/navigation/primaryNav'
import { HOME_THREAD_ROUTE_PATTERN } from '@/routes/paths'

export function useChatRouterRefs() {
  const location = useLocation()
  const navigate = useNavigate()
  const threadMatch = useMatch({ path: HOME_THREAD_ROUTE_PATTERN, end: true })
  const activePrimaryKey = getPrimaryKeyFromPath(location.pathname)
  const chatAbortRef = useRef(null)
  const prevDisplayThreadRef = useRef(null)
  const urlThreadId = threadMatch?.params?.threadId ?? null

  return {
    location,
    navigate,
    threadMatch,
    activePrimaryKey,
    urlThreadId,
    chatAbortRef,
    prevDisplayThreadRef,
  }
}
